import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;

    window.setTimeout(() => {
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
          //   behavior: "instant", // to skip the scrolling animation
          });
    }, 600)
  }, [pathname, hash]);

  return null;
}